module.exports = __webpack_public_path__ + "static/img/pinterest.d917406.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pinterest.png
// module id = Rqdp
// module chunks = 1